<template>
  <div>
    <div class="pop-payment-wrap" v-if="!useYn">
      <div class="pop-header">
        <span class="pop-title">멤버십 포인트</span>
        <button
          class="btn-pop-close"
          @click="
            $.emit('close');
            useYn = false;
          "
        >
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body">
        <div class="fieldset">
          <span class="h2">결제금액</span>
          <div class="ip-row">
            <label for="payAmount">결제금액</label>
            <input
              type="text"
              class="ip-comm"
              id="payAmount"
              :value="
                (complexUprc > 0 ? complexUprc : totalCash)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              readonly
            />
          </div>
        </div>
        <div class="fieldset">
          <span class="h2">회원정보</span>
          <div class="ip-row">
            <label for="memCloud">클라우드 멤버십</label>
            <input
              type="text"
              class="ip-comm center"
              id="memCloud"
              value="00000"
              readonly
            />
          </div>
          <div class="ip-row col04">
            <label for="avaPoint">가용포인트</label>
            <input
              type="text"
              class="ip-comm center"
              id="avaPoint"
              value="1,000,000"
              readonly
            />
            <label for="accPoint">누적포인트</label>
            <input
              type="text"
              class="ip-comm center"
              id="accPoint"
              value="1,000,000"
              readonly
            />
          </div>
        </div>
        <div class="fieldset">
          <span class="h2">사용포인트</span>
          <div class="ip-row">
            <label for="usePoint">사용포인트</label>
            <input
              type="text"
              class="ip-comm center"
              id="usePoint"
              v-model="usePoint"
            />
          </div>
        </div>
      </div>
      <div class="pop-btn-area">
        <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
        <!-- <button type="button" class="btn-pop btn-fourth btn-main">동글키패드<span class="overlay"></span></button> -->
        <button type="button" class="btn-pop btn-fourth btn-main">
          멀티패드<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop btn-half btn-submit"
          @click="payInPoint()"
        >
          포인트 사용<span class="overlay"></span>
        </button>
      </div>
    </div>

    <div class="pop-payment-wrap" v-else>
      <div class="pop-header">
        <span class="pop-title">멤버십 포인트</span>
        <button
          class="btn-pop-close"
          @click="
            $.emit('close');
            useYn = false;
          "
        >
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body">
        <div class="fieldset">
          <span class="h2">회원정보</span>
          <div class="ip-row">
            <label for="memCloud">클라우드 멤버십</label>
            <input
              type="text"
              class="ip-comm center"
              id="memCloud"
              value="00000"
            />
          </div>
          <div class="ip-row col04">
            <label for="memName">회원명</label>
            <input type="text" class="ip-comm center" id="memName" value="0" />
            <label for="memNum">회원번호</label>
            <input type="text" class="ip-comm center" id="memNum" value="0" />
          </div>
          <div class="ip-row">
            <label for="payCardNum">카드번호</label>
            <input
              type="text"
              class="ip-comm center"
              id="payCardNum"
              value="1111111111111111"
            />
          </div>
          <div class="ip-row col04">
            <label for="avaPoint">가용포인트</label>
            <input type="text" class="ip-comm center" id="avaPoint" value="0" />
            <label for="accPoint">누적포인트</label>
            <input type="text" class="ip-comm center" id="accPoint" value="0" />
          </div>
        </div>
      </div>
      <!-- 버튼이 두개인 경우에 아래 요소에 클래스명 btn02 추가 -->
      <div class="pop-btn-area">
        <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
        <button type="button" class="btn-pop btn-fourth btn-main">
          멀티패드<span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-half btn-submit">
          적립<span class="overlay"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "membershipPoint",
  data() {
    return {
      useYn: false,
      totalCash: this.totalUprc - this.totalDiscount - this.receivedUprc,
      usePoint: 0,
    };
  },
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    payType: String,
    isComplex: Boolean,
    membersTotalUprc: Number,
    complexUprc: Number,
  },
  methods: {
    inputPoint() {},
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    async payInPoint() {
      if (this.isComplex) {
        this.$.emit("close");
        this.$.emit("closeComplexMembers", this.usePoint);
        this.$.emit("addComplexPayArr", this.usePoint, "point");
      } else {
        await this.loadingPromise("포인트를 조회 중 입니다.");

        if (this.usePoint >= this.totalCash) {
          await this.loadingPromise("영수증 출력 중입니다.");
        }
        this.$.emit("setReceivedUprc", this.usePoint, this.payType);
        this.$.emit("close");
      }
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


